<template>
  <div v-if="!isEmpty" class="question-setting">
    <el-tabs type="card" v-model="activeTab" class="flex-tabs">
      <el-tab-pane label="问题设置" name="0"> </el-tab-pane>
    </el-tabs>
    <div class="mt-5 text-large text-theme-black-850 font-medium leading-22 font-MEDIUM">
      <span>Q{{ question.num }}.</span>
      <span>题目设置</span>
    </div>
    <div class="text-theme-black-850 question-setting-item font-MEDIUM">
      <div class="leading-22 mb-3 font-bold text-medium">
        <span>整体设置</span>
      </div>
      <ul :key="question.q_id">
        <li>
          <div class="w-full">
            <div class="flex-between">
              <span>题干说明</span>
              <el-switch v-model="question.setting.enableNote" @change="onUpdate" />
            </div>
            <div v-if="question.setting.enableNote" class="card-box flex-between">
              <span>内容较长时折叠展示</span>
              <el-switch v-model="question.setting.enableFold" @change="onUpdate" />
            </div>
          </div>
        </li>
        <li v-if="changeTypes">
          <span>切换题型</span>
          <el-select size="mini-x" v-model="question.question_type" class="short-box" @change="onChangeIssue">
            <el-option v-for="item in changeTypes" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </li>
      </ul>
    </div>
  </div>
  <div v-else>
    <div class="text-center text-theme-black-450" style="padding-top: 200px">
      <span style="font-size: 40px">
        <i class="icon-bianji1"></i>
      </span>
      <div class="leading-22 mt-4 text-medium">
        <span>没有选定的题目</span>
        <br />
        <span>请添加或者选择一个题目</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { changeTypeMap } from '@/question/detaults-config'
import { getCtor } from '@/question/factory'

export default {
  data() {
    return {
      activeTab: '0'
    }
  },
  computed: {
    QType() {
      return this.question?.question_type
    },
    isEmpty() {
      return !this.question
    },
    question() {
      return this.selectQuestion
    },
    changeTypes() {
      return changeTypeMap.get(this.QType)
    },
    ...mapGetters(['selectQuestion', 'selectIssueItem'])
  },
  methods: {
    onChangeIssue() {
      let Ctor = getCtor(this.question.question_type)
      this.question.issue = new Ctor(this.question.issue)
      this.onUpdate()
    },
    onUpdate() {
      this.$emit('on-update', this.question)
    }
  }
}
</script>

<style></style>
